// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";
import {ETagRequest} from "@reapptor-apps/reapptor-react-common";

export default class ListMyBookingsRequest extends ETagRequest {

    public asCaptain: boolean = false;

    public activeOnly: boolean = false;

    public readonly isListMyBookingsRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof ListMyBookingsRequest) || ((from as any).isListMyBookingsRequest === true));
    }

    public static as(from?: object | null): ListMyBookingsRequest | null {
        return (ListMyBookingsRequest.is(from)) ? from as ListMyBookingsRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(ListMyBookingsRequest, "ListMyBookingsRequest");